import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { FLIGHTS_SEARCH } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { flightsSearch: bffResponse };
}

export default function useFlightSearch(options, query = FLIGHTS_SEARCH) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(query, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables } = {}) =>
      restRequest({ method: 'POST', path: '/air-api/v1/flights/search', body: variables }).then(
        toGraphqlShape,
      ),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
